import styled, { keyframes } from 'styled-components';

import { ds } from '@/config/colors';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

/* Pusty stan strony w stylistyce DS (jak TableEmptyState): wyrównanie do lewej, bez ramek
   i kolorowych kafli, akcja jako czarny pill. Ilustracja zostaje mała i stonowana. */
export const EmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 32px 0 48px;
  text-align: left;
  animation: ${fadeIn} 0.35s ease-out;
`;

export const EmptyStateIconWrapper = styled.div<{ $isError?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: ${ds.bgMuted};
  color: ${({ $isError }) => ($isError ? '#dc2626' : ds.textSecondary)};
  margin-bottom: 20px;

  svg {
    width: 24px;
    height: 24px;
  }
`;

export const EmptyStateTitle = styled.h3`
  font-size: 20px;
  font-weight: 600;
  color: ${ds.textPrimary};
  margin: 0 0 6px 0;
  line-height: 1.3;
`;

export const EmptyStateDescription = styled.p`
  font-size: 15px;
  color: ${ds.textSecondary};
  line-height: 1.55;
  max-width: 520px;
  margin: 0 0 20px 0;
`;

export const EmptyStateActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
`;

export const EmptyStateActionLink = styled.a<{ $disabled?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 44px;
  padding: 0 20px;
  border-radius: 9999px;
  font-size: 14px;
  font-weight: 500;
  font-family: inherit;
  line-height: 1.2;
  color: #ffffff;
  background: ${ds.accentInk};
  border: 1px solid ${ds.accentInk};
  text-decoration: none;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};
  pointer-events: ${({ $disabled }) => ($disabled ? 'none' : 'auto')};
  transition: background 0.15s ease, border-color 0.15s ease;

  &:hover {
    background: ${ds.accentInkHover};
    border-color: ${ds.accentInkHover};
    text-decoration: none;
  }
`;

export const EmptyStateSvgWrapper = styled.div<{ $isError?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  color: ${({ theme, $isError }) => {
    if ($isError) return '#dc2626';
    return theme.mode === 'dark' ? '#6b7280' : '#9ca3af';
  }};

  svg {
    width: auto;
    height: 72px;
  }
`;

export const EmptyStateFooterLink = styled.p`
  display: none;
`;
